// TODO: later use from payment web ui
export const CONST_INSTRUCTED = 'INSTRUCTED';
export const CONST_GBP_EQUIVALENT = 'GBP_EQUIVALENT';
export const CONST_EQUIVALENT = 'EQUIVALENT';
export const CONST_AMOUNT_UPPERCASE = 'AMOUNT';
export const REVIEWED = 'REVIEWED';
export const PENDING = 'PENDING';
export const VERIFIED = 'VERIFIED';
export const SOFT = 'SOFT';
export const HARD = 'HARD';
export const MD_COLUMN_24 = 24;
export const MD_COLUMN_12 = 12;
export const UPLOAD = 'Upload';
export const CONST_YOU = 'you';
export const brands = {
	VM: 'VM',
	CB: 'CB',
	YB: 'YB',
};
